import React from 'react';
import ProductDetailTabTypeDetailsFields from './ProductDetailTabTypeDetailsFields';

function ViewProductDetailTabType({ TabTypeData }) {
  return (
    <div className="card-body px-0">
      <ProductDetailTabTypeDetailsFields formData={TabTypeData} readOnly />
    </div>
  );
}

export default ViewProductDetailTabType;
